import { render, staticRenderFns } from "./PackagingIndex.vue?vue&type=template&id=7c170730"
import script from "./PackagingIndex.vue?vue&type=script&lang=js"
export * from "./PackagingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports